import styled from "styled-components";
import Skeleton from '@mui/material/Skeleton';
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";
import UploadFileComp from "../components/UploadFileComp";
import { useSearchParams, useNavigate } from 'react-router-dom';
import AppDelegate from "../AppDelegate";
import { useEffect , useState } from "react";

import {
  Box,
} from '@mui/material';

const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;


const Upload = () => {
  const [searchParams] = useSearchParams();
  const navigate  = useNavigate();
  const [validLink, setValidLink]  = useState(true);

  const caseId = searchParams.get('cid');
  const token = searchParams.get('t');

  useEffect(() => {
    validateParam();
  }, []);

  const validateParam = async () => {
    const response = await AppDelegate.reqValidateUploadLink({
      caseId: caseId,
      token: token,
    });

    if (response.code === 200) {
      setValidLink(true);
    } else {
      navigate("/error");
    }
  };

  return (
    <Container>
      <Topbar />
        <Box sx={{
          width: '100%',
          backgroundColor: 'var(--light-gray)',
        }}>
          <Box sx={{
            padding: "100px 50px",
            maxWidth: 800,
            margin: "0 auto",
            textAlign: 'center',
          }}>
            <Box>
              <h1 style={{
                fontSize: "2rem",
              }}>Upload Your Data File</h1>
              <p>Securely upload your mobile data file for extraction and processing. Our system supports most mobile backup and data file formats.</p>
            </Box>
              {validLink &&
                <UploadFileComp caseId={caseId} token={token} />
              }
              {!validLink &&
                <Box sx={{
                  mt: 6,
                  maxWidth: '700px',
                }}>
                  <Skeleton variant="rounded" width={700} height={400} />
                </Box>
              }
          </Box>
        </Box>
      <Footer/>
    </Container>
  );
};

export default Upload;
